<template>
    <div>
        <b-dropdown-item @click="open">
            <font-awesome-icon icon="fa-duotone fa-share" class="mr-1" />
            Share
        </b-dropdown-item>

        <b-modal v-model="modal" hide-footer centered title="Share Video">
            <div v-if="currentCreatorVideo">
                <b-input-group class="my-1">
                    <b-form-input
                        :value="currentCreatorVideo.creatorVideo.urlVanity"
                        readonly
                    />
                    <b-input-group-append>
                        <b-btn @click="copyUrl" variant="primary">
                            Copy
                        </b-btn>
                    </b-input-group-append>
                </b-input-group>

                <div class="small text-success" v-if="hasCopied">
                    <font-awesome-icon icon="fa-light fa-check" />
                    URL has been copied
                </div>

                <div v-if="qrCode" class="text-center mt-4">
                    <h6>Scan QR Code</h6>
                    <img
                        class="rounded"
                        style="
                            height: 200px;
                            width: 200px;
                            background-color: #fff;
                        "
                        :src="qrCode"
                    />
                </div>
                <div v-else class="text-center mt-4">
                    <generic-loading />
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { mapState } from "vuex";

import copy from "clipboard-copy";

export default {
    data() {
        return {
            modal: false,
            qrCode: null,
            hasCopied: false,
        };
    },
    computed: {
        ...mapState("videoPlayer", ["currentCreatorVideo"]),
    },
    methods: {
        open() {
            this.hasCopied = false;
            this.qrCode = null;
            this.modal = true;
            this.refreshQrCode();
        },
        copyUrl() {
            copy(this.currentCreatorVideo.creatorVideo.url);
            this.hasCopied = true;
        },
        refreshQrCode() {
            this.api
                .post(
                    `/creatorVideo/${this.currentCreatorVideo.creatorVideo.id}/qrcode`
                )
                .then((response) => {
                    if (response?.data?.qrCode) {
                        this.qrCode = response.data.qrCode;
                    }
                });
        },
    },
};
</script>
